export default __webpack_public_path__ + "locales/pt/Files.json?hash=687cc428104f41f8cac90bdce6fbde80";